import { NgModule } from '@angular/core';
import { Route, RouterModule, Routes, UrlSegment } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { unsavedActivateGuard, unsavedChangesGuard } from './core/guards/unsaved-navigate.guard';
import { AppLayoutComponent } from './layout/component/app-layout/app-layout.component';
import { claimsGuard } from './core/guards/claims.guard';

const routes: Routes = [
    {
        path: 'selector',
        canActivate: [unsavedActivateGuard],
        loadChildren: () => import('./modules/system-selector/system-selector.module').then((m) => m.SystemSelectorModule)
    },
    { path: 'reset-password/:token', loadChildren: () => import('./modules/auth/login/login.module').then((m) => m.LoginModule) },
    {
        path: '',
        component: AppLayoutComponent,
        canMatch: [layoutCanMatch],
        canActivateChild: [authGuard, unsavedChangesGuard],
        children: [
            { path: '', redirectTo: 'hse', pathMatch: 'full' },
            {
                path: 'administracion-blister',
                loadChildren: () => import('./modules/administracion-blister/administracion-blister.module').then((m) => m.AdministracionBlisterModule)
            },
            {
                path: 'perfil',
                loadChildren: () => import('./modules/perfil/perfil.module').then((m) => m.PerfilModule)
            },
            {
                path: 'hse',
                data: { claims: [], claimPrefixes: ['HSE_'], requireAll: true, moduleName: 'HSE' },
                canActivate: [claimsGuard],
                loadChildren: () => import('./modules/hse/hse.module').then((m) => m.HseModuleModule)
            },
            {
                path: 'rrhh',
                data: { claims: [], claimPrefixes: ['RRHH_'], requireAll: true, moduleName: 'RRHH' },
                canActivate: [claimsGuard],
                loadChildren: () => import('./modules/RRHH/rh.module').then((m) => m.RhModuleModule)
            },
            {
                path: 'medio-ambiente',
                data: { claims: [], claimPrefixes: ['MA_'], requireAll: true, moduleName: 'Medio Ambiente' },
                canActivate: [claimsGuard],
                loadChildren: () => import('./modules/medio-ambiente/ma.module').then((m) => m.MaModuleModule)
            },
            {
                path: 'documentation',
                loadChildren: () => import('./modules/documentation/documentation.module').then((m) => m.DocumentationModule)
            },
            // {
            //     path: 'uikit',
            //     loadChildren: () => import('./modules/uikit/uikit.routes')
            // },
            // {
            //     path: 'pages',
            //     loadChildren: () => import('./modules/pages.routes')
            // },
            {
                path: 'usuarios',
                data: { claims: ['SISTEMA_USUARIOS'] },
                canActivate: [claimsGuard],
                loadChildren: () => import('./modules/usuarios/usuarios.module').then((m) => m.UsuariosModule)
            },
            {
                path: 'lineas-servicio',
                loadChildren: () => import('./modules/lineas-servicio/lineas-servicio.module').then((m) => m.LineasServicioModule)
            },
            {
                path: 'empresas',
                loadChildren: () => import('./modules/empresas/empresas.module').then((m) => m.EmpresasModule)
            },
            {
                path: 'documentos',
                loadChildren: () => import('./modules/documentos/documentos.module').then((m) => m.DocumentosModule)
            },
            {
                path: 'imagenes-dashboard',
                loadChildren: () => import('./modules/imagenes-dashboard/imagenes-dashboard.module').then((m) => m.ImagenesDashboardModule)
            },
            {
                path: 'parametros',
                data: { claims: ['SISTEMA_PARAMETROS'] },
                canActivate: [claimsGuard],
                loadChildren: () => import('./modules/parametros/parametros.module').then((m) => m.ParametrosModule)
            },
            {
                path: 'tipo-documento',
                loadChildren: () => import('./modules/tipo-documento/tipo-documento.module').then((m) => m.TipoDocumentoModule)
            },
            {
                path: 'notificaciones',
                loadChildren: () => import('./modules/notifications/notifications.module').then((m) => m.NotificationsModule)
            },
            {
                path: 'servicio',
                loadChildren: () => import('./modules/servicio/servicio.module').then((m) => m.ServicioModule)
            },
            {
                path: 'calendario',
                loadChildren: () => import('./modules/calendario/calendario.module').then((m) => m.CalendarioModule)
            },
            {
                path: 'faq',
                loadChildren: () => import('./modules/faq/faq.module').then((m) => m.FaqModule)
            }
        ]
    },
    {
        path: 'auth',
        children: [
            { path: 'login', loadChildren: () => import('./modules/auth/login/login.module').then((m) => m.LoginModule) },
            { path: 'access', loadChildren: () => import('./modules/auth/access/access.module').then((m) => m.AccessModule) }
        ]
    },
    { path: 'landing', loadChildren: () => import('./modules/landing/landing/landing.module').then((m) => m.LandingModule) },
    { path: 'notfound', loadChildren: () => import('./modules/notfound/notfound.module').then((m) => m.NotfoundModule) },
    { path: ':system/notfound', loadChildren: () => import('./modules/notfound/notfound.module').then((m) => m.NotfoundModule) },
    { path: 'login', loadChildren: () => import('./modules/auth/login/login.module').then((m) => m.LoginModule) },
    { path: 'acceso-denegado', loadChildren: () => import('./modules/unauthorized/unauthorized-module').then((m) => m.UnauthorizedModule) },
    { path: '**', redirectTo: 'notfound' }
];

const PUBLIC_PATHS = new Set(['selector', 'login', 'auth', 'landing', 'notfound', 'acceso-denegado', 'reset-password']);

function layoutCanMatch(segments: UrlSegment[], _route: Route) {
    // CanMatch debe decidir en base a la URL objetivo (segments), no a la URL actual del navegador.
    const first = (segments[0]?.path || '').toLowerCase();
    return !first || !PUBLIC_PATHS.has(first);
}

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {}
